(function() {
  var el = document.querySelector('[data-store-locator-id]');
  if (!el) return;
  var id = el.getAttribute('data-store-locator-id');
  var days = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
  var today = days[new Date().getDay()];
  var activeState = '';
  var searchVal = '';
  var currentPage = 0;
  var PAGE_SIZE = 24; 
  var INITIAL_SIZE = 9;
  var MOBILE_INITIAL_SIZE = 4;
  var allStores = [];

  var C = {
    card: 'ai-store-locator-card-' + id,
    cardContent: 'ai-store-locator-card-content-' + id,
    cardName: 'ai-store-locator-card-name-' + id,
    cardAddress: 'ai-store-locator-card-address-' + id,
    cardHours: 'ai-store-locator-card-hours-' + id,
    cardBtn: 'ai-store-locator-card-btn-' + id,
    tab: 'ai-store-locator-tab-' + id
  };

  var grid = document.getElementById('sl-grid-' + id);
  var loading = document.getElementById('sl-loading-' + id);
  var empty = document.getElementById('sl-empty-' + id);
  var tabsEl = document.getElementById('sl-tabs-' + id);

  var STOREFRONT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'api/2024-01/graphql.json';
  var STOREFRONT_TOKEN = el.getAttribute('data-storefront-token') || '';

  var GQL_QUERY = 'query GetStores($cursor: String) { metaobjects(type: "sidekick_store_location", first: 250, after: $cursor) { pageInfo { hasNextPage endCursor } nodes { fields { key value } } } }';

  function parseFields(fields) {
    var obj = {};
    fields.forEach(function(f) { obj[f.key] = f.value; });
    return obj;
  }

  function fetchPage(cursor) {
    return fetch(STOREFRONT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN },
      body: JSON.stringify({ query: GQL_QUERY, variables: { cursor: cursor || null } })
    }).then(function(r) { return r.json(); });
  }

  function fetchAllStores(cursor, acc) {
    acc = acc || [];
    return fetchPage(cursor).then(function(data) {
      var mo = data && data.data && data.data.metaobjects;
      if (!mo) return acc;
      (mo.nodes || []).forEach(function(node) { acc.push(parseFields(node.fields)); });
      if (mo.pageInfo && mo.pageInfo.hasNextPage) return fetchAllStores(mo.pageInfo.endCursor, acc);
      return acc;
    });
  }

  function buildCard(store) {
    var name = store.store_name || '';
    var address = store.full_address || '';
    var mapsUrl = store.maps_url || '';
    var hours = '—';
    try { var h = JSON.parse(store.operating_hours || '{}'); hours = h[today] || '—'; } catch(e) {}

    var card = document.createElement('div');
    card.className = C.card;

    var content = document.createElement('div');
    content.className = C.cardContent;

    var nameEl = document.createElement('p');
    nameEl.className = C.cardName;
    nameEl.textContent = name;

    var addrEl = document.createElement('p');
    addrEl.className = C.cardAddress;
    addrEl.textContent = address;

    var hoursEl = document.createElement('p');
    hoursEl.className = C.cardHours;
    hoursEl.style.fontSize = '14px';
    hoursEl.innerHTML = '<strong>Today: </strong>' + hours;

    content.appendChild(nameEl);
    content.appendChild(addrEl);
    content.appendChild(hoursEl);

    if (mapsUrl) {
      var btn = document.createElement('a');
      btn.className = C.cardBtn;
      btn.style.fontSize = '14px';
      btn.href = mapsUrl;
      btn.target = '_blank';
      btn.rel = 'noopener';
      btn.textContent = 'Get Directions';
      content.appendChild(btn);
    }

    card.appendChild(content);
    return card;
  }

  function buildTabs(states) {
    tabsEl.innerHTML = '';
    states.forEach(function(state) {
      var btn = document.createElement('button');
      btn.className = C.tab;
      btn.setAttribute('data-state', state);
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', 'false');
      btn.textContent = state;
      btn.addEventListener('click', function() { selectTab(state); });
      tabsEl.appendChild(btn);
    });
  }

  function selectTab(state) {
    activeState = state;
    searchVal = '';
    currentPage = 0;
    var searchEl = document.getElementById('sl-search-' + id);
    if (searchEl) searchEl.value = '';
    tabsEl.querySelectorAll('.' + C.tab).forEach(function(t) {
      var isActive = t.getAttribute('data-state') === state;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    renderVisible();
  }

  function getFilteredStores() {
    var isSearching = searchVal !== '';
    return allStores.filter(function(s) {
      var stateMatch = isSearching || (s.state || '').trim().toUpperCase() === activeState;
      var searchMatch = !isSearching ||
        (s.store_name || '').toLowerCase().includes(searchVal) ||
        (s.full_address || '').toLowerCase().includes(searchVal);
      return stateMatch && searchMatch;
    });
  }

  function renderVisible() {
    var filtered = getFilteredStores();
    var isMobile = screen.width < 768;
    var initSize = isMobile ? MOBILE_INITIAL_SIZE : INITIAL_SIZE;
    var visible = filtered.slice(0, currentPage === 0 ? initSize : initSize + currentPage * PAGE_SIZE);

    grid.innerHTML = '';
    var fragment = document.createDocumentFragment();
    visible.forEach(function(s) { fragment.appendChild(buildCard(s)); });
    grid.appendChild(fragment);

    empty.style.display = visible.length === 0 ? 'block' : 'none';

    var wrapper = getViewAllBtn();
    var btn = wrapper.querySelector('button');
    var hasMore = filtered.length > visible.length;

    if (filtered.length > INITIAL_SIZE) {
      wrapper.style.display = 'block';
      if (hasMore) {
        btn.textContent = 'Show More';
        btn.onclick = function() { currentPage++; renderVisible(); };
      } else {
        btn.textContent = 'Show Less';
        btn.onclick = function() { currentPage = 0; renderVisible(); window.scrollTo({top: tabsEl.offsetTop - 20, behavior: 'smooth'}); };
      }
    } else {
      wrapper.style.display = 'none';
    }
  }

  function getViewAllBtn() {
    var existing = document.getElementById('sl-viewall-' + id);
    if (existing) return existing;
    var wrapper = document.createElement('div');
    wrapper.id = 'sl-viewall-' + id;
    wrapper.style.cssText = 'text-align:center;margin-top:24px;';
    var btn = document.createElement('button');
    btn.id = 'sl-viewall-btn-' + id;
    btn.style.cssText = 'padding:10px 32px;border:2px solid currentColor;border-radius:50px;background:transparent;font-size:16px !important;font-weight:600;cursor:pointer;';
    wrapper.appendChild(btn);
    grid.parentNode.insertBefore(wrapper, grid.nextSibling);
    return wrapper;
  }

  function renderAll(stores) {
    allStores = stores;
    var stateSet = {};
    stores.forEach(function(s) { var st = (s.state || '').trim().toUpperCase(); if (st) stateSet[st] = true; });
    var STATE_ORDER = [
      'KUALA LUMPUR','SELANGOR','PUTRAJAYA','NEGERI SEMBILAN','PAHANG',
      'JOHOR','KEDAH','MELAKA','PENANG','PERAK','KELANTAN','TERENGGANU',
      'PERLIS','SABAH','SARAWAK','LABUAN'
    ];
    var orderedStates = STATE_ORDER.filter(function(s) { return stateSet[s]; });
    buildTabs(orderedStates);
    loading.style.display = 'none';
    grid.style.display = '';
    if (orderedStates.length > 0) selectTab(orderedStates[0]);
  }

  var searchEl = document.getElementById('sl-search-' + id);
  if (searchEl) {
    searchEl.addEventListener('input', function() {
      searchVal = this.value.toLowerCase().trim();
      currentPage = 0;
      renderVisible();
    });
  }

  fetchAllStores().then(renderAll).catch(function(err) {
    loading.textContent = 'Unable to load store locations. Please refresh the page.';
    console.error('Store locator error:', err);
  });
})();
